import React from "react";
import { motion } from "framer-motion";
import speakYourMind from "./Images/speakmind2.jpg";
import image2 from "../../../Images/coursecard_images/speakmind_1.jpg";
import image1 from "../../../Images/coursecard_images/speakmind_2.jpg";
import image3 from "../../../Images/coursecard_images/speakmind_3.jpg";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Nav from "../../../Nav";

const SpeakYourMind = () => {
  return (
    <>
      <motion.div
        className="p-5 font-sans bg-gray-100 h-4/5 mt-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Page Title */}
        <h1 className="text-4xl font-extrabold text-gray-600 text-center mb-8">
          Speak Your Mind
        </h1>

       
      </motion.div>

      <Nav />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            py: 5,
            fontFamily: "Arial, sans-serif",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${speakYourMind})`,
              backgroundSize: "cover",
              py: 10,
              textAlign: "center",
              color: "#fff",
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#fff",
                }}
              >
                Speak Your Mind
              </Typography>
            </Container>
          </Box>

          <Container
            maxWidth="lg"
            sx={{ backgroundColor: "#ffffff", p: 5, borderRadius: 2, mt: -8 }}
          >
            <Grid container spacing={5} alignItems="flex-start">
              <Grid item xs={12} lg={6}>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Have you{" "}
                  <b>
                    <u>
                      <i>already attended an English course</i>
                    </u>
                  </b>{" "}
                  in the past but your
                  <b>
                    <u>
                      <i> speaking hasn’t improved? </i>
                    </u>
                  </b>
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  You want to{" "}
                  <i>
                    <b>
                      stop translating English words and sentences into your
                      language
                    </b>
                  </i>{" "}
                  and encourage you to think and speak in the English language.
                  You want to{" "}
                  <i>
                    <b>
                      <u>
                        feel more confident with your vocabulary and able to
                        express your ideas.
                      </u>
                    </b>
                  </i>
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  We understand that part all too well and{" "}
                  <b>
                    <u>
                      <i>offer you the change you expect.</i>
                    </u>
                  </b>
                  Speak Your Mind is a practical English program based on a full
                  immersion.
                  <b>
                    <u>
                      <i>
                        Our primary focus is on mastering your English skills
                        which are essential in real-life situations.
                      </i>
                    </u>
                  </b>
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Don’t feel confused with phrases, or expressions such as
                  idioms or phrasal verbs in English. Use the opportunity to
                  include those in your vocabulary and start using them on the
                  spot in real-life examples. Idioms are naturally used in
                  English by native speakers.
                </Typography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={speakYourMind}
                    alt="Fresh Start"
                    sx={{ borderRadius: 2 }}
                  />
                </motion.div>
              </Grid>
            </Grid>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              In case you start using them in your spoken English you will be
              surprised how easy the communication has become for you. On the
              other hand, you will be able to understand others and you will not
              feel you’re always missing the point in English.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              Let’s have a look at some situations where English comes in handy:
            </Typography>
            <List>
              {[
                "Enjoy the food and <i><u><strong>don’t worry about the vocabulary in your restaurant menu.</strong></u></i>",
                "<i><u><strong>Explain the customer service the problem</strong></u></i> you’re having with the new device you just bought...",
                "<i><u><strong>Discuss topics on Facebook, Instagram, and news</strong></u></i> you read with your colleagues during coffee breaks or with friends.",
                "It’s not just work, work, work! You can <i><u>start a chit-chat or small talk with people</u></i> simply for fun. <i><u><strong>But you need to know how to communicate to do that.</strong></u></i>",
                "In case you just got hired and and discovered you will need to use <i><u><strong>English at work - that’s just another great opportunity to start using English daily and it will only help you learn the language better.</strong></u></i> ",
                "<i><u><strong>Don’t be afraid of English - embrace it and make it a part of your life.</strong></u></i>",
              ].map((challenge, index) => (
                <ListItem key={index}>
                  <CheckCircle color="primary" sx={{ mr: 2 }} />
                  <ListItemText
                    primary={
                      <Typography
                        dangerouslySetInnerHTML={{ __html: challenge }}
                      />
                    }
                    primaryTypographyProps={{
                      sx: { fontFamily: "Arial, sans-serif" },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <Grid item xs={12} lg={6}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardMedia
                  component="img"
                  image={image1}
                  alt="Fresh Start"
                  sx={{
                    width: "100%",
                    paddingBottom: "19px",
                    borderRadius: 2,
                    alignItems: "flex-start",
                  }}
                />
              </motion.div>
            </Grid>
            <CardContent>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Don’t only use what you learn in your English class during your
                lesson. Go out there, and apply what you have learned in English
                at work, take notes for yourself in English, start watching news
                in English, or sometimes switch your movie subtitle to English
                and not your native language.
                <i>
                  <u>
                    <b>
                      Activate yourself, and take an initiative - and the change
                      will come to you.
                    </b>
                  </u>
                </i>
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                The key decision you can make today is to leave your comfort
                zone. Do you think English pronunciation is difficult? Well,
                take up a new challenge, and make it count.
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                In case you always do the same things, for example, choose your
                language subtitles - how will you learn new words in English?
                Put a goal ahead of you and challenge yourself!
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Jumpstart your English and transform in less than 3 months. It’s
                a very feasible change and it’s available for you - in case you
                make up your mind. If you need to speak English because you know
                it will get you promoted at work you are already motivated. Why
                not use your motivation to improve your English as well?
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                If you see you can get hired for a new job you always wanted
                that sounds like a great motivation to improve your speaking and
                pronunciation. After all, you want people to understand you
                clearly, and you want to be understood as well.
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                It’s not easy to avoid misunderstanding even when 2 people speak
                the same language. Just imagine how difficult it is to avoid
                misunderstandings when people come from two different cultures
                and speak different languages. Your clarity, your pronunciation,
                and your listening skills will help you eliminate those problems
                in life and at work.
              </Typography>
              <Grid item xs={12} lg={11} container spacing={2}>
                <Grid item xs={6} paddingBottom={"20px"}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <CardMedia
                      component="img"
                      image={image2}
                      alt="Fresh Start"
                      sx={{ borderRadius: 2 }}
                    />
                  </motion.div>
                </Grid>
                <Grid item xs={6}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <CardMedia
                      component="img"
                      image={image3}
                      alt="Fresh Start"
                      sx={{ borderRadius: 2 }}
                    />
                  </motion.div>
                </Grid>
              </Grid>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                My goal is to equip you with the tools necessary to grow and
                develop professionally and in your private life.
              </Typography>
              <List>
                {[
                  "Getting there by <i><u><strong>Speaking Your Mind - where you need to use English in practice and not in theory will get you there.</strong></u></i>",
                  "Improve your confidence at work and in daily life",
                  "<i><strong>Be yourself</strong></i> and make others understand <u><strong>YOU</strong></u>",
                  "If you are understood by others they will accept you easier and faster",
                  "The faster you fit in the faster you will see the benefits of learning English",
                  "English is a powerful vehicle, and you can just join the ride",
                ].map((challenge, index) => (
                  <ListItem key={index}>
                    <Typography color="primary" sx={{ mr: 2 }}>
                      -
                    </Typography>
                    <ListItemText
                      primary={
                        <Typography
                          dangerouslySetInnerHTML={{ __html: challenge }}
                        />
                      }
                      primaryTypographyProps={{
                        sx: { fontFamily: "Arial, sans-serif" },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>
                  <i>
                    <b>Join our community</b>
                  </i>
                </u>{" "}
                of like-minded people who know how much English can help them
                and share your experiences with us.
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Speak your mind and make yourself understood!!
              </Typography>
            </CardContent>
            <div className="flex flex-col md:flex-row gap-6 items-center justify-center">
          {/* Card 1: Course Details */}
          <div className="w-full md:w-1/2 bg-green-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Online 1-on-1 Lesson
            </h2>
            <p className="text-gray-700 mb-2">
              <strong>Type of course:</strong> Online 1-on-1 lesson
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Number of lessons:</strong> 30 online lessons (1 hour
              each)
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Price:</strong> $560
            </p>
            <p className="italic text-gray-600 mt-4 text-center">
              Contact us by mail to put your name on the waiting list.
            </p>
          </div>

          {/* Card 2: Bundle Pricing */}
          <div className="w-full md:w-1/2 bg-blue-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Bundle Price Option
            </h2>
            <p className="text-gray-700 mb-4 text-center">
              <strong>Bundle Price:</strong> $715 for a bundle package, which
              includes the following courses:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                <strong>English At Work</strong> - 1 year access, a
                self-studying course (group live classes are NOT included).{" "}
                <em>(You Save $240)</em>
              </li>
              <li>
                <strong>Dictation Course</strong> - 1 year access, a
                self-studying course. <em>(You Save $280)</em>
              </li>
              <li>
                <strong>Intonation Course</strong> - 1 year access, a
                self-studying course. <em>(You Save $260)</em>
              </li>
              <li>
                <strong>Vocabulary Booster</strong> - 1 year access, a
                self-studying course. <em>(You Save $290)</em>
              </li>
            </ul>
            <p className="mt-4 font-bold text-center">
              Save: $1,070 by purchasing this bundle package.
            </p>

            <div className="mt-6 text-sm text-gray-600">
              <p className="font-semibold">Important:</p>
              <ul className="list-disc list-inside space-y-1 mt-2">
                <li>Only adults are eligible to take our lessons.</li>
                <li>Each price listed is per student.</li>
                <li>
                  If you request a refund for the "Speak Your Mind" course
                  within 14 days of your payment, your access to the Bundle
                  courses will be revoked.
                </li>
              </ul>
            </div>
          </div>
        </div>
            <Box textAlign="center" mb={10} mt={2}> 
              <Button 
                variant="contained"
                color="primary"
                size="large"
                sx={{ borderRadius: 5, px: 5, py: 2 }}
              >
                Join Now
              </Button>
            </Box>
          </Container>
        </Box>
      </motion.div>
    </>
  );
};

export default SpeakYourMind;
